import * as THREE from 'three';
import BakedModel from '../Utils/BakedModel';
export default class OfficeDesk {
    constructor(scene, resources) {
        this.scene = scene;
        this.resources = resources;
        this.setupLights();
        this.bakeModel();
        this.setModel();
    }
    setupLights() {
        // Ambient light
        // const ambientLight = new THREE.AmbientLight(0xffffff, 0.1);
        // ambientLight.layers.set(0);
        // this.scene.add(ambientLight);
        // // Directional light
        // const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
        // directionalLight.position.set(5, 10, 7.5);
        // directionalLight.layers.set(0); // Set layer 1 for the light
        // directionalLight.castShadow = true;
        // this.scene.add(directionalLight);
        // // Point light
        // const pointLight = new THREE.PointLight(0xffffff, 1, 100);
        // pointLight.position.set(5, 5, 5);
        // pointLight.castShadow = true;
        // pointLight.layers.set(0); // Set layer 1 for the light
        // this.scene.add(pointLight);
    }
    bakeModel() {
        const textureMap = {
            Plane273_1: this.resources.items.texture.cactusTexture,
            Plane273_2: this.resources.items.texture.computerTexture,
            Plane273_7: this.resources.items.texture.tapeGlassTexture,
            Plane273_5: this.resources.items.texture.tableTexture,
            Plane273_4: this.resources.items.texture.sigaTexture,
            Plane273_6: this.resources.items.texture.tapeTexture,
            Plane273: this.resources.items.texture.fileboxTexture,
            Plane273_10: this.resources.items.texture.lampsTexture,
            Plane273_9: this.resources.items.texture.officeStoolBinTexture,
            Plane273_3: this.resources.items.texture.photoTexture,
            Plane273_8: this.resources.items.texture.clipboardTexture,
        };
        this.bakedModel = new BakedModel(Object.assign(Object.assign({}, this.resources.items.gltfModel.officeDeskModel), { name: 'office' }), this.resources.items.texture.computerTexture, 1000, textureMap);
    }
    setModel() {
        const model = this.bakedModel.getModel();
        // model.position.set(0, 0, -10000); // Adjust the position as needed
        model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.castShadow = true;
                child.receiveShadow = true;
            }
        });
        this.scene.add(model);
    }
}
